import { DateTime } from 'luxon'

type ResponseAction =
  | {
      type: 'updateAnswerText'
      questionUrl: string
      text: string
    }
  | { type: 'setSurveyUrl'; surveyUrl: string }

export interface ResponseState {
  containerUrl: string
  surveyUrl: string
  surveyStartedAt: DateTime
  answers: Array<{
    answerText: string
    questionUrl: string
    lastUpdated: DateTime
  }>
}

export function responseReducer(
  state: ResponseState,
  action: ResponseAction
): ResponseState {
  switch (action.type) {
    case 'setSurveyUrl':
      return {
        ...state,
        surveyUrl: action.surveyUrl,
      }
    case 'updateAnswerText':
      return {
        ...state,
        answers: [
          ...state.answers.filter(a => a.questionUrl !== action.questionUrl),
          {
            questionUrl: action.questionUrl,
            lastUpdated: DateTime.now(),
            answerText: action.text,
          },
        ],
      }
    default:
      throw new Error(`Invalid action: '${JSON.stringify(action)}'`)
  }
}

// Helper functions
